import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const Container = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`

// Renders the YR widget as an iframe
// NOTE we are for now switching on Astrosite.  They support a coordinat but do rounf
const YRWidget = ({ latitude, longitude }) => {
  return (
    <Container
      src={`https://www.yr.no/en/content/${latitude},${longitude}/meteogram.svg`}
    ></Container>
  )
}

YRWidget.propTypes = {
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
}

export default YRWidget
